import { base_contentBackground } from 'ext-ui/style/colors'
import React from 'react'
import * as style from 'src/app/CardFeedCreate/CardFeedCreate.style'
import SvgCheckNew from 'src/components/Svgs/SvgCheckNew'
import { useTranslate } from 'src/localization/Trns'

import type { WizardStep } from './CardFeedCreate'

interface StepperProps {
  currentStep: WizardStep
}

const STEPS: { step: WizardStep; key: string }[] = [
  { step: 1, key: 'Contact Bank' },
  { step: 2, key: 'Enter Feed Details' },
  { step: 3, key: 'Review Enrollment Terms' },
]

const Stepper: React.FC<StepperProps> = ({ currentStep }) => {
  const translate = useTranslate()

  return (
    <nav aria-label={translate('Card Feeds enrollment progress')}>
      <h2 css={style.stepperTitle}>{translate('Get Started')}</h2>
      <ol css={style.stepperList} data-testid="card-feed-create-stepper">
        {STEPS.map(({ step, key }) => {
          const isCompleted = step < currentStep
          const isActive = step === currentStep
          const liClassName = isActive ? 'active' : undefined

          return (
            <li
              key={step}
              css={style.stepperItem}
              className={liClassName}
              aria-current={isActive ? 'step' : undefined}
              data-testid={`card-feed-create-step-${step}`}
              data-state={
                isCompleted ? 'completed' : isActive ? 'active' : 'upcoming'
              }
            >
              {isCompleted ? (
                <span css={style.stepBadgeCompleted} aria-hidden="true">
                  <SvgCheckNew
                    stroke={base_contentBackground}
                    width={14}
                    height={14}
                  />
                </span>
              ) : isActive ? (
                <span css={style.stepBadgeActive} aria-hidden="true">
                  {step}
                </span>
              ) : (
                <span css={style.stepBadgeUpcoming} aria-hidden="true">
                  {step}
                </span>
              )}
              <span className="step-label">{translate(key)}</span>
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

export default Stepper
